<template>
  <div class="logoff-page">
    <div class="logoff-main">
      <div style="font-weight: 900; font-size: 16px">阅读游戏账号注销条件</div>
      <div style="font-weight: 900; font-size: 16px">并在页面底部勾选确认</div>
      <p style="font-size: 14px; font-family: FZLTHK--GBK1-0">
        《游戏账号注销条件》
      </p>
      <div>
        <div style="font-size: 14px; font-family: FZLTHK--GBK1-0">
          <div v-for="(item, index) in logoffMsg" :key="index">
            <span>{{ item.list }}</span>
            <span>{{ item.msg }}</span>
          </div>
          <div class="spec-remind">特别提示：</div>
          <span
            >由于用户该账号在本游戏中存在多端登陆的情况，每个端登陆的同账号信息都会被注销。一旦该账号被注销,除法律法规及游戏账号注销协议另有规定外，基于该账号的信息相关数据也将进行删除或者匿名化处理。</span>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <div class="footer">
      <div @click="chosebox" style="background:#fff">
        <p class="check-big-box">
          <span class="check-box" :class="{ chose: choseBol }"></span>
        </p>
        <span style="font-size: 13px; font-family: FZLTHK--GBK1-0">
          我已详细阅读并满足账号注销条件
        </span>
      </div>
      <button @click="gotonext" class="logoff-btn">下一步</button>
    </div>
  </div>
</template>
<script>
import { getEnv  } from "../utils/getEnv.js"

export default {
  name: "LogOff",
    data(){
      return {
        getEnv,
        choseBol:false,
        logoffMsg:[
        {list:'1.账号处于安全及正常使用状态:',msg:'您的账号属于正常使用过程中，且无被封、被盗等风险;'},
        {list:'2.游戏收益已结清或得到妥善处理:',msg:'包括但不限于钻石、金条、银币、金币、角色、道具等权益。请您妥善处理,若未处理，视为您自愿放弃该等收益;'},
        {list:'3.如存在组队关系，需退出小队保证队伍仅有该角色一人',msg:';'},
        {list:'4.账号无任何纠纷:',msg:'包括投诉举报、被投诉举报、国家机关调查、仲裁、诉讼等纠纷;'},
        {list:'5.角色已经离线，即已经退出游戏',msg:';'}
        ]
      }
    },
    mounted(){
      this.getUidEnv()
    },
    methods:{
      getUidEnv(){
        let _params = location.search//获取?之后的参数 
        let str =_params.substr(1) 
        let strs = str.split("&"); 
        let parmObj = {}
        for(var i = 0; i < strs.length; i ++) {
          parmObj[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
          sessionStorage.setItem( unescape(strs[i].split("=")[0]), unescape(strs[i].split("=")[1]))
        }
      //  console.log(parmObj['uid'])
      //   console.log(68,parmObj['env'])
      },
      chosebox () {
        this.choseBol = !this.choseBol
      },
       gotonext () {
        if(!this.choseBol) {
          return alert('请勾选我已阅读...') 
        }
        this.$router.push('/offdetail');
      } 
    },
};
</script>

<style scoped lang="scss">
.logoff-page {
  height: 100%;
  background: #fff;
  padding: 2.5rem;
  .logoff-main {
    width: 100%;
    overflow-y: auto;
    height: 31.25rem;
    .spec-remind {
      margin: 5px 0;
    }
  }
  .footer {
    box-shadow: 0 0 1px #ccc;
    position: fixed;
    bottom: 0.375rem;
    left: 0px;
    right: 0px;
    text-align: center;
    padding: 10px;
    .check-big-box {
      display: inline-block;
      width: 0.625rem;
      height: 0.625rem;
      border-radius: 0.625rem;
      border: 1px solid black;
      line-height: 0.625rem;
      margin-left: 0.3125rem;
      text-align: center;
      .check-box {
        display: inline-block;
        width: 0.325rem;
        height: 0.325rem;
        border-radius: 0.325rem;
        margin-bottom: 0.185rem;
      }
    }
    .chose {
      background: blue;
    }
    .logoff-btn {
      background: #234ed0;
      border: none;
      width: 100%;
      height: 40px;
      text-align: center;
      border-radius: 20px;
      font-size: 18px;
      color: #fff;
    }
  }
}
</style>
